import {
    ISimplePresentation,
    ISimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {KennethMustDie} from "../KennethMustDie";
import {gsap} from "gsap";
import {
    IFeatureInfo,
    KMD_SYMBOL_ANIMATIONS,
    SPECIAL_SYMBOL_NAMES,
    X_NUDGE_ANIMATIONS,
    X_WAYS_ANIMATIONS
} from "../server/IKMDData";
import {KMDSymbol} from "../reels/KMDSymbol";
import {SimpleReelModel, SimpleReelModelSymbolData} from "../../core/reel/simplereel/SimpleReelModel";
import {KMDSound} from "../sound/KMDSound";

export class KMDSpecialRowXWaysExpandRunner implements ISimplePresentation {

    public shouldRun(): boolean {
        return (KennethMustDie.model.xWaysSpecialRow.length > 0);
    }

    public start(controller: ISimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = gsap.timeline({
                delay: 0.2,
                onComplete: () => {
                    controller.finish();
                }
            }),
            xWaysData: IFeatureInfo[] = KennethMustDie.model.xWaysSpecialRow;

        tl.add(() => {
            KennethMustDie.reelView.toggleMask(false);
            KennethMustDie.specialReelView.toggleMask(false);

            controller.setSkipCallback(() => {
                this.onSkip(tl);
            });

            // #240
            KennethMustDie.soundPlayer.playSound(KMDSound.X_WAYS_GROW);
        }, 0);

        xWaysData.forEach((xWay: IFeatureInfo) => {
            const infectedReelId: number = xWay.originReelId,
                reel: SimpleReelModel = KennethMustDie.reelView.reelModels[infectedReelId],
                allSymbols: SimpleReelModelSymbolData[] = reel.stopSymbols,
                yPos: number[] = [-25, -75, -125];

            const xWaysSymbol: KMDSymbol = (KennethMustDie.specialReelView.reel.getStopSymbolAt(xWay.originSymId).positionable as KMDSymbol);
            tl.add([
                xWaysSymbol.setState(X_WAYS_ANIMATIONS.EXPAND_UP_4),
                () => {
                    xWaysSymbol.hideSymbolCount();
                }
            ], 0).timeScale(0.75); // #528 -> pt 3

            tl.add(() => {
                allSymbols.forEach((value: SimpleReelModelSymbolData, symId: number) => {
                    let sym: KMDSymbol = (value.positionable as KMDSymbol),
                        state: string = KMD_SYMBOL_ANIMATIONS.HALF,
                        ts: number = 1;
                    const multi: number = KennethMustDie.model.gameData.multiplier[infectedReelId][symId];

                    if (sym.originalName === SPECIAL_SYMBOL_NAMES.X_NUDGE_WILD) {
                        if (symId === 1) {
                            state = X_NUDGE_ANIMATIONS.FULL_200;
                            sym.m1m2NameHelperXNudge = state;
                        } else if (symId === 2) {
                            state = X_NUDGE_ANIMATIONS.UP_1_STEP + X_NUDGE_ANIMATIONS.NO_WIN_HELPER;
                            sym.m1m2NameHelperXNudge = X_NUDGE_ANIMATIONS.HELPER_300;
                            ts = 10;
                        }

                        // #537 -> this happened in the case where a sticky xNudge(symId === 1) was behind sticky xNudge(symId === 2).
                        sym.resizeLevel = 1;

                        sym.setState(state).timeScale(ts).eventCallback("onComplete", () => {
                            sym.translateY(yPos[value.reelPosition] - 25, false);
                        });
                    } else {
                        sym.resizeAsPerXWays(1, multi);
                        if (["S", "X_NUDGE_WILD"].indexOf(sym.name) === -1) {
                            sym.displayLines(multi);
                        }
                        sym.translateY(yPos[value.reelPosition], false);

                        // #485
                        if (sym.name === SPECIAL_SYMBOL_NAMES.S) {
                            KennethMustDie.nearWinAnticipation.resizeAnticipationFire(infectedReelId, yPos[symId]);
                        }

                        // #548
                        if (infectedReelId === 2) {
                            KennethMustDie.nearWinAnticipation.resizeXHAnticipationFire();
                        }
                    }

                    if (KennethMustDie.stickyXNudges.checkIfSticky(infectedReelId, symId)) {
                        KennethMustDie.stickyXNudges.changeLockSize(infectedReelId, symId - 1);
                    } else if (KennethMustDie.stickyWilds.checkIfSticky(infectedReelId, symId)) {
                        KennethMustDie.stickyWilds.changeLockSize(infectedReelId, symId, 100);
                    }
                });
            }, 0.3333);

        });

        tl.to(this, {
            duration: 0.1
        });
    }

    private onSkip(tl: gsap.core.Timeline): void {
        tl.totalProgress(1);
    }
}